import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import background from "../Imagenes/FondoSolution.jpg";
import { FaCheckCircle } from "react-icons/fa";
import ArrowAnimation from "../utilities/ArrowAnimation";
import AbstractBackground from "../components/AbstractBackground";
const Solution = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2
    });
    const currentRef = sectionRef.current;
    if (currentRef) observer.observe(currentRef);
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);
  const features = [{
    text: "Diseñamos",
    desc: "software funcional y a la medida de cada necesidad."
  }, {
    text: "Optimizamos",
    desc: "procesos con herramientas innovadoras y efectivas."
  }, {
    text: "Garantizamos",
    desc: "calidad y rendimiento en cada solución creada."
  }];
  return <>
      <div id="nosotros" ref={sectionRef} className="relative overflow-hidden bg-[#0e0f11] py-44">
        {/* Línea decorativa superior */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#bdff57]/30 to-transparent" />
        {/* Fondo tipo Portafolio: puntos + glows */}
        <AbstractBackground variant="dots" />
        <div className="mx-auto max-w-[100rem] px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
            <div className="justify-center lg:pr-8">
              <div className="lg:max-w-lg">
                <motion.div initial={{
                x: -100,
                opacity: 0
              }} animate={isVisible ? {
                x: 0,
                opacity: 1
              } : {}} transition={{
                duration: 1.1,
                ease: "easeOut"
              }} className="text-3xl max-md:text-center font-normal text-white sm:text-7xl">
                  <div className="max-md:text-center">
                    <span className="inline-block px-4 py-1.5 mb-8 text-sm font-medium text-[#bdff57] border border-[#bdff57]/30 rounded-full bg-[#bdff57]/5">
                      Sobre nosotros
                    </span>
                  </div>

                  <h2 className="text-4xl sm:text-6xl lg:text-7xl max-md:text-center font-normal tracking-tight text-white">
                    La <span className="text-[#bdff57]">solución</span> que necesitas
                  </h2>

                </motion.div>

                <motion.div initial={{
                x: -100,
                opacity: 0
              }} animate={isVisible ? {
                x: 0,
                opacity: 1
              } : {}} transition={{
                duration: 0.8,
                ease: "easeOut",
                delay: 0.5
              }} className="mt-6 text-lg/8 text-gray-400">
                  <ArrowAnimation /> Somos <span className="font-bold text-gray-200">Vitrum</span>, una empresa tecnológica que desarrolla
                  <span className="font-bold text-gray-200"> soluciones innovadoras</span> que potencian negocios y optimizan
                  procesos. Entendemos las necesidades del mercado y aplicamos
                  nuestra experiencia para ofrecer software <span className="font-bold text-gray-200">eficiente, escalable </span>
                  y de <span className="font-bold text-gray-200">alta calidad</span>.
                </motion.div>

                <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={isVisible ? {
                opacity: 1,
                y: 0
              } : {}} transition={{
                duration: 0.8,
                ease: "easeOut",
                delay: 0.5
              }} className="mt-10 space-y-5">
                  {features.map((feature, index) => <div key={index} className="flex items-center gap-4 group">
                      <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#bdff57]/10 flex items-center justify-center">
                        <FaCheckCircle className="w-4 h-4 text-[#bdff57]" />
                      </div>
                      <p className="text-gray-300 text-sm sm:text-base">
                        <span className="font-semibold text-white">{feature.text}</span>{' '}
                        {feature.desc}
                      </p>
                    </div>)}
                </motion.div>


              </div>
            </div>
            {/* Imagen */}
            <motion.img initial={{
            x: 25,
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 1.1,
            ease: "easeOut",
            delay: 0.5
          }} loading="lazy" src={background} placeholder="blur" alt="Dashboard" className="w-[42rem] max-w-none rounded-xl ring-1 shadow-xl ring-gray-400/10 md:w-[70rem] md:-ml-4 lg:-ml-0" width="2432" height="1442" />

          </div>
        </div>
      </div>
    </>;
};
export default Solution;